<template>
    <Bar :data="chartData" :options="chartOptions" />
</template>

<script>
import { Bar } from "vue-chartjs";
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
} from "chart.js";
import { formatTimeFromMs } from "@/utils/timeFormatUtils";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

function msToHours(ms) {
    return (ms || 0) / 3600000;
}

function hoursTickToLabel(value) {
    if (value === 0) return "0h:0m";
    return formatTimeFromMs(value * 3600000);
}

export default {
    name: "StatisticsTopProjectsChart",
    components: { Bar },
    props: {
        projects: {
            type: Array,
            default: () => [],
        },
        limit: {
            type: Number,
            default: 10,
        },
    },
    computed: {
        top() {
            return (this.projects || []).slice(0, this.limit);
        },
        regularMsList() {
            return this.top.map(
                (p) => (p.totalMs || 0) - (p.overtimeMs || 0)
            );
        },
        overtimeMsList() {
            return this.top.map((p) => p.overtimeMs || 0);
        },
        chartData() {
            return {
                labels: this.top.map((p) => p.projectName),
                datasets: [
                    {
                        label: "Regular",
                        backgroundColor: "#1B5E20",
                        borderRadius: 4,
                        stack: "hours",
                        data: this.regularMsList.map(msToHours),
                    },
                    {
                        label: "Overtime",
                        backgroundColor: "#C62828",
                        borderRadius: 4,
                        stack: "hours",
                        data: this.overtimeMsList.map(msToHours),
                    },
                ],
            };
        },
        chartOptions() {
            const regularMsList = this.regularMsList;
            const overtimeMsList = this.overtimeMsList;
            return {
                indexAxis: "y",
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: true, position: "top" },
                    title: { display: false },
                    tooltip: {
                        callbacks: {
                            label(ctx) {
                                const idx = ctx.dataIndex;
                                const ms =
                                    ctx.datasetIndex === 0
                                        ? regularMsList[idx]
                                        : overtimeMsList[idx];
                                return `${ctx.dataset.label}: ${formatTimeFromMs(ms)}`;
                            },
                            footer(items) {
                                if (!items.length) return "";
                                const idx = items[0].dataIndex;
                                const total =
                                    (regularMsList[idx] || 0) +
                                    (overtimeMsList[idx] || 0);
                                return `Total: ${formatTimeFromMs(total)}`;
                            },
                        },
                    },
                },
                scales: {
                    x: {
                        stacked: true,
                        beginAtZero: true,
                        title: { display: true, text: "Time" },
                        ticks: {
                            callback: hoursTickToLabel,
                        },
                    },
                    y: { stacked: true },
                },
            };
        },
    },
};
</script>
